module.exports = __webpack_public_path__ + "img/widget.165f407b.svg";